import { SchemaOf, object, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';
import { SearchCustomers } from '@/graphql/contracts/_generated_/searchCustomers.query';

export type Customer = NonNullable<
SearchCustomers['searchContractsAndCustomers']
>['customers'][number];

export interface Fields {
  parentCustomerID: string;
}

export type CustomerOption = { label: string; value: string };

export const validationSchema: SchemaOf<Fields> = object().shape({
  parentCustomerID: string()
    .test((newParentId, { options, createError }) => {
      const currentCustomerID = options.context?.customerID;
      if (currentCustomerID && newParentId && currentCustomerID === newParentId) {
        return createError({
          path: 'parentCustomerID',
          message: 'You cannot link a customer to yourself',
        });
      }

      return true;
    })
    .test((newParentId, { options, createError }) => {
      const currentParentCustomerID = options.context?.parentCustomerID;
      if (currentParentCustomerID && newParentId && currentParentCustomerID === newParentId) {
        return createError({
          path: 'parentCustomerID',
          message: 'Customer already linked to this parent',
        });
      }

      return true;
    })
    .required(REQUIRED_FIELD),
});
